import { Component } from '@theme/component';
import { DialogCloseEvent } from '@theme/dialog';

/**
 * The "Shop Now" trigger on an Instagram Stories slide. Puppet-clicks the theme's
 * real, hidden quick-add engine (`<quick-add-component>`) nested inside it — always
 * the "Choose options" button specifically (not whichever of "Add"/"Choose" is
 * currently active, unlike the product-card quick-shop trigger), since a story slide
 * should always open the quick-add modal rather than silently add a single-variant
 * product straight to cart. Mirrors the puppet-click pattern used by
 * `product-quick-shop.js`/`sticky-add-to-cart.js`: reuse the real add-to-cart/modal
 * logic untouched, only the visible trigger is custom.
 *
 * Also pauses the story (its auto-advance timer/progress bar) for as long as the
 * quick-add modal it opens stays open, resuming once the shopper closes it — the
 * story keeps auto-advancing behind an open modal otherwise.
 *
 * @extends {Component}
 */
class StorySlideCta extends Component {
  /**
   * Forwards the click to the real quick-add "Choose options" button, which always
   * opens the quick-add modal regardless of the product's variant count.
   * @param {Event} event
   */
  handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const target = this.querySelector('.quick-add__button--choose');
    if (!(target instanceof HTMLElement)) return;

    const stories = /** @type {any} */ (this.closest('stories-component'));
    stories?.pause?.();

    const dialog = document.getElementById('quick-add-dialog');
    dialog?.addEventListener(DialogCloseEvent.eventName, () => stories?.resume?.(), { once: true });

    target.click();
  };
}

if (!customElements.get('story-slide-cta')) {
  customElements.define('story-slide-cta', StorySlideCta);
}
